import { render, staticRenderFns } from "./myHome.vue?vue&type=template&id=0b40baf1&scoped=true&"
import script from "./myHome.vue?vue&type=script&lang=js&"
export * from "./myHome.vue?vue&type=script&lang=js&"
import style0 from "./myHome.vue?vue&type=style&index=0&id=0b40baf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40baf1",
  null
  
)

export default component.exports